<template>
    <div class="border border-gray-400 px-3 sm:px-6 pb-6 mt-2 mt-8 sm:-mt-px mb-8">
        <div class="font-bold pt-6 text text-blue-500 tracking-wide uppercase">
            {{ $t('Earnest Money') }}
        </div>

        <earnest-money-total-due
            :deal="deal"
            :read_only="read_only"
        />

        <earnest-money-received
            :commercial="commercial"
            :read_only="read_only"
        />

        <earnest-money-toward-purchase
            :commercial="commercial"
            :read_only="read_only"
        />

        <earnest-money-non-refundable
            :earnest_money_non_refundable="earnest_money_non_refundable"
            :commercial="commercial"
            :read_only="read_only"
            @input="updateEarnestMoneyNonRefundable"
        />

        <earnest-money-non-refundable-date
            v-if="earnest_money_non_refundable"
            :commercial="commercial"
            :read_only="read_only"
        />

        <earnest-money-extend
            :read_only="read_only"
        />
    </div>
</template>

<script>
import EarnestMoneyTotalDue from './earnest-money-total-due.vue';
import EarnestMoneyReceived from './earnest-money-received.vue';
import EarnestMoneyTowardPurchase from './earnest-money-toward-purchase.vue';
import EarnestMoneyExtend from './earnest-money-extend.vue';
import EarnestMoneyNonRefundable from './earnest-money-non-refundable.vue';
import EarnestMoneyNonRefundableDate from './earnest-money-non-refundable-date.vue';

export default {
    components: {
        EarnestMoneyTotalDue,
        EarnestMoneyReceived,
        EarnestMoneyTowardPurchase,
        EarnestMoneyExtend,
        EarnestMoneyNonRefundable,
        EarnestMoneyNonRefundableDate,
    },

    data() {
        return {
            earnest_money_non_refundable: this.commercial.earnest_money_non_refundable,
        }
    },

    props: {
        commercial: { default: () => ({}) },
        deal: { default: () => ({}) },
        read_only: { default: false },
    },

    methods: {
        updateEarnestMoneyNonRefundable(val) {
            this.earnest_money_non_refundable = val;
        },
    },
}
</script>
